import React, { useCallback, useState } from 'react';
import { pick } from 'ramda';
import { usePortletSelector, usePortletTranslations } from 'js/components/system/Portlet';
import { mapConversion, mapTemplates } from './selector';
import Card from './Card';
import style from './index.scss';

export default () => {
    const t = usePortletTranslations();
    const { conversion, bonusTemplates } = usePortletSelector(pick(['conversion', 'bonusTemplates']));
    const templates = mapTemplates({ bonusTemplates, conversion });
    const bonusCashConversion = mapConversion({ conversion });
    const [expanded, setExpanded] = useState(null);
    const onExpand = useCallback(val => setExpanded(val === expanded ? null : val), [expanded]);

    if (!templates.length) {
        return <span className={style.error}>{t('noBonuses')}</span>;
    }

    return (
        <>
            <h3 className={style.descriptionTitle}>{t('cardsTitle')}</h3>
            <div className={style.list}>
                {templates.map((card, index) => {
                    const conversionForBonus = bonusCashConversion.find(item => item.bonusTemplateCode === card.code);

                    return (
                        <Card
                            key={index}
                            card={card}
                            conversion={conversionForBonus}
                            expanded={expanded === conversionForBonus.conversionRuleId}
                            onExpand={onExpand}
                        />
                    );
                })}
            </div>
        </>
    );
};
